import { getCandidateDetails } from '../api/CandidateApi';

export const fetchCandidateDetails = (id) => async (dispatch) => {
    try {
        const result = await getCandidateDetails(id);
        if (result?.data) manageCandidateActions(result?.data, dispatch);
        else if (result?.error) {
            let notify = { msg: result.error, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
        }
    } catch (error) {
        return error;
    }
};

const manageCandidateActions = (candidateData, dispatch) => {
    if (candidateData) {
        const { profile, status, jobs_applied, Document_upload, ...candidateInfo } =
            candidateData?.candidate_profile_data;
        const { document_types, open_positions } = candidateData;
        dispatch({ type: 'FETCH_PROFILE', payload: profile });
        dispatch({ type: 'FETCH_STATUS', payload: status });
        dispatch({ type: 'FETCH_JOBS_APPLIED', payload: jobs_applied });
        dispatch({ type: 'FETCH_DOCUMENT_UPLOAD', payload: Document_upload });
        dispatch({ type: 'FETCH_OPEN_POSITIONS', payload: open_positions });
        dispatch({ type: 'FETCH_DOCUMENT_TYPES', payload: document_types });
        dispatch({ type: 'FETCH_CANDIDATE_INFO', payload: candidateInfo });
    } else {
        window.localStorage.clear();
        window.location.replace('/');
    }
};
